import React, { useCallback, useState } from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import { Row, Col } from "antd";

import { warn } from "../../../modules/messages";
import { saveData } from "../../../modules/saveFile";
import UploadFile from "../../app/generic/uploadFile";
import { post } from "../../../modules/httpFunctions";
import TableHeader from "../../app/generic/tableHeader";
import { handleError } from "../../../modules/errorLogger";
import TooltipButton from "../../app/generic/tooltipButton";
import ImportResult from "../../import/importFile/importResult";
import FilterButton from "../../app/generic/tableFilter/filterButton";

function TemplateListHeader({
  push,
  templates,
  showFilter,
  loadTemplates,
  onFilterClick,
}) {
  const intl = useIntl();
  const handleNewClick = useCallback(() => {
    push("/new-template");
  }, [push]);

  const handleExportClick = useCallback(() => {
    templates &&
      templates !== "e" &&
      saveData(
        `[${templates.map((t) => t.json).join(",")}]`,
        "template_export_import.json",
        "text/plain;charset=utf-8"
      );
  }, [templates]);

  const [resultData, setResultData] = useState();
  const [modalVisible, setModalVisible] = useState();
  const handleModalClose = useCallback(() => {
    setModalVisible(false);
    setTimeout(() => setResultData(), 1000);
  }, []);
  const handleImportClick = useCallback(
    ({ file, onError, onProgress, onSuccess }) => {
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          post(
            "consignment/template/bulk",
            reader.result,
            true,
            360000,
            false,
            ({ total, loaded }) => {
              onProgress({ percent: Math.round((loaded / total) * 100) }, file);
            },
            false
          )
            .then(({ data: response }) => {
              if (response) {
                setModalVisible(
                  response.importResults && response.importResults.length > 0
                );
                setResultData(response);
                onSuccess(response, file);
                loadTemplates();
              } else {
                warn(
                  intl.formatMessage({
                    id: "consignment.template.import.error",
                    defaultMessage:
                      "Při načítání šablon zásilek nastala chyba, zkuste to prosím znovu.",
                  })
                );
              }
            })
            .catch((err) => {
              handleError(err);
              onError(err);
            });
        },
        false
      );
      reader.readAsText(file);
    },
    [intl, loadTemplates]
  );

  return (
    <>
      <ImportResult
        entity="template"
        visible={modalVisible}
        whatFourth={intl.formatMessage({
          id: "consignment.template.what",
          defaultMessage: "šablon zásilek",
        })}
        resultData={resultData}
        onClose={handleModalClose}
      />
      <TableHeader
        title={intl.formatMessage({
          id: "consignment.template.list",
          defaultMessage: "Šablony zásilek",
        })}
        left={<FilterButton showFilter={showFilter} onClick={onFilterClick} />}
        right={
          <Row gutter={[0, 8]}>
            <Col>
              <TooltipButton
                icon="export"
                className="margin-right-2"
                onClick={handleExportClick}
                text={intl.formatMessage({
                  id: "consignment.template.export",
                  defaultMessage: "Export",
                })}
                title={intl.formatMessage({
                  id: "consignment.template.export.title",
                  defaultMessage: "Export šablon pro následný import do WA",
                })}
              />
              <UploadFile
                onlyButton
                requestMethod={handleImportClick}
                buttonText={intl.formatMessage({
                  id: "consignment.template.import",
                  defaultMessage: "Import",
                })}
                buttonTitle={intl.formatMessage({
                  id: "consignment.template.import.title",
                  defaultMessage: "Import šablon ve formátu z Exportu šablon",
                })}
              />
            </Col>
            <Col>
              <TooltipButton
                icon="plus"
                onClick={handleNewClick}
                text={intl.formatMessage({
                  id: "consignment.template.createNew",
                  defaultMessage: "Vytvořit novou šablonu",
                })}
              />
            </Col>
          </Row>
        }
      />
    </>
  );
}

export default connect(null, { push })(TemplateListHeader);
